// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_DEFAULT_TEMPLATE_LIST = 'defaultTemplate/SET_DEFAULT_TEMPLATE_LIST';
export const ADD_DEFAULT_TEMPLATE_ITEM = 'defaultTemplate/ADD_DEFAULT_TEMPLATE_ITEM';
export const SET_DEFAULT_TEMPLATE_ITEM = 'defaultTemplate/SET_DEFAULT_TEMPLATE_ITEM';
export const UNSET_DEFAULT_TEMPLATE_ITEM = 'defaultTemplate/UNSET_DEFAULT_TEMPLATE_ITEM';
export const REMOVE_DEFAULT_TEMPLATE_ITEM = 'defaultTemplate/REMOVE_DEFAULT_TEMPLATE_ITEM';
export const UPDATE_DEFAULT_TEMPLATE_ITEM = 'defaultTemplate/UPDATE_DEFAULT_TEMPLATE_ITEM';
export const SET_DEFAULT_TEMPLATE_ITEM_IS_DELETING = 'defaultTemplate/SET_DEFAULT_TEMPLATE_ITEM_IS_DELETING';
